module.exports = __webpack_public_path__ + "assets/img/922189.f3d28ee9.jpg";